<template>
  <div class="content">
    <!-- start of search -->
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <!-- 公司名称 -->
          <div class="search-area-div">公司名称</div>
          <el-select size="mini" v-model="page.tenantGuid" placeholder="请选择" clearable filterable class="ipt-sty">
            <el-option v-for="item in tenantList"
              :key="item.guid"
              :label="item.tenantName"
              :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <!-- search btn -->
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <!-- end of search -->

    <!-- start of list -->
    <div class=" back-color-fff content-main-box" >
      <div class="button-area p16">
        <el-button size="mini" type="info" @click="addPath">新增代征平台</el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData" :height="tableHeight" stripe border v-loading="tableLoading" style="width:100%"
        :row-key="(row) => row.guid">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <!-- 公司名称 -->
        <el-table-column prop="tenantName" min-width="180" label="公司名称" header-align="center" align="left" fixed="left" show-overflow-tooltip>
        </el-table-column>
        <!-- 合同编号 -->
        <el-table-column prop="contractVO.contractCode" min-width="150" label="合同编号" header-align="center" align="left" show-overflow-tooltip>
        </el-table-column>
        <!-- 合同名称 -->
        <el-table-column prop="contractVO.contractName" min-width="150" label="合同名称" header-align="center" align="left" show-overflow-tooltip>
        </el-table-column>
        <!-- 签约企业 -->
        <el-table-column prop="contractVO.tenantName" label="签约企业" header-align="center" width="180" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ (scope.row.contractVO && scope.row.contractVO.tenantName) ? scope.row.contractVO.tenantName : '-' }}</template>
        </el-table-column>
        <!-- 合作税率 -->
        <!-- <el-table-column prop="cooperationTaxRate" width="120" label="合作税率" header-align="center" align="right" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.cooperationTaxRate ? (scope.row.cooperationTaxRate + '%') : '-' }}
          </template>
        </el-table-column> -->
        <!-- 费用类型 -->
        <el-table-column prop="cooperationTaxRate" min-width="160" label="费用类型" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.cooperationTaxRate || scope.row.cooperationTaxRate == 0">{{ 'SAAS服务费率: ' + scope.row.cooperationTaxRate + '%' }}</span>
            <span v-else-if="scope.row.costMoney || scope.row.costMoney == 0">{{ 'SAAS服务费: ' + scope.row.costMoney + '(万元)' }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <!-- 合作期限 -->
        <el-table-column prop="cooperationValidityDate" width="120" label="合作期限" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span :style="{ color: (!scope.row.cooperationValidityDate || (new Date().getDate() <= new Date(scope.row.cooperationValidityDate).getDate())) ? '': 'red' }">
              {{ scope.row.cooperationValidityDate | getDate }}
            </span>
          </template>
        </el-table-column>
        <!-- 资质是否完整 -->
        <el-table-column prop="isUrlComplete " width="120" label="资质是否完整" header-align="center" align="left">
          <template slot-scope="scope">
            {{ scope.row.isUrlComplete == 'Y' ? '是': '否' }}
          </template>
        </el-table-column>
        <!-- 公司类型 -->
        <el-table-column prop="enterpriseCate" width="120" label="公司类型" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.enterpriseCate == '9904' ? '代征平台': '代缴平台' }}</template>
        </el-table-column>
        <!-- 创建人 -->
        <el-table-column prop="createUserName" width="96" label="创建人" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.createUserName || '-' }}
          </template>
        </el-table-column>
        <!-- 创建时间 -->
        <el-table-column prop="inputTime" width="120" label="创建时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.inputTime | getDate }}</template>
        </el-table-column>
        <!-- 操作时间 -->
        <el-table-column prop="updateTime" width="120" label="操作时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateTime | getDate }}</template>
        </el-table-column>
       
        <el-table-column label="操作" header-align="center" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <a class="txt-color" @click="editPath(scope.row)">编辑 | </a>
            <a class="txt-color-red" @click="getDeleteData( scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>

      <!-- start of pagination -->
      <el-pagination class="pt pb back-color-fff content-pagination-box" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]" :current-page="page.pageIndex"
        :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
      </el-pagination>
      <!-- end of pagination -->
    </div>
    <!-- end of list -->

  </div>
</template>

<script>
export default {
  data() {
    return {
      tableHeight: window.innerHeight - 280,
      page: {
        'pageIndex': 1,
        'pageSize': 50,
        'tenantGuid': ''
      },
      // 公司名称下拉选数据
      tenantList: [],
      tableData: [],
      tableLoading: false,

    };
  },
  created() {
    this.getData(true);
    this.getTenantDatas();
  },
  methods: {
    getTenantDatas() {
      let that = this;
      that.api.postJson(
        `/${serverConfig.msCustomerService}/tenant/data/get`,
        {
          // 企业分类(00 平台；0101 医药生产；010201 商业流通公司；010203 COS企业；9901 运营公司；9902 劳务公司；9903 代缴公司；9904 代征公司对应mf_enterprise_cate表中的值)
          "enterpriseCate": '9904',
          // 'enterpriseCates': ['9903', '9904'],
          "pageIndex": 1,
          "pageSize": -1
        }
      ).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          // console.log(res.data)
          this.tenantList = res.data.data.records || [];
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getDeleteData(guid) {
      let self = this;
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        self.api.postJson(`/${serverConfig.msCustomerService}/tenant-check/levy-check/delete`, [guid]).then(res => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('删除成功');
            self.getData(true);
          } else {
            self.$message.error(res.data.msg);
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
    },
    empty() {
      let self = this;
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        tenantGuid: ''
      }

      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant-check/levy-check/list`, self.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableLoading = false;
          self.tableData = (res.data.data && res.data.data.records) ? res.data.data.records : [];
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    addPath() {
      this.$router.push({
        path: '/maintenanceRegularEidt',
        query:{
          productGuid:this.$route.query.productGuid
        }
      });
    },
    editPath(row) {
      this.$router.push({
        name: 'maintenanceRegularEidt',
        query: { guid: row.guid, tenantGuid: row.tenantGuid,productGuid:this.$route.query.productGuid},
        params: {
          form: JSON.stringify({
            guid: row.guid,
            contractGuid: row['contractGuid'],
            contractName: row.contractVO['contractName'],
            tenantGuidA: row.contractVO.tenantGuid,
            tenantNameA: row.contractVO.tenantName,
            tenantGuid: row.tenantGuid,
            tenantName: row.tenantName,
            contacts: row.contacts,
            contactTel: row.contactTel,
            inputTime: row.inputTime,
            isContinueCooperation: row.isContinueCooperation,
            monthMaxMoney: row.monthMaxMoney,
          })
        }
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val || 1;
      this.getData();
    },
  },
};
</script> 
<style lang="less" scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.el-range-editor.el-input__inner {
  padding: 0px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #DCDFE6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}

.content-main-box {
  height: calc(100vh - 60px - 35px - 66px);
}
.el-table {
  border-bottom: 1px solid #D9D9D9;
}
</style>